import { Checkbox } from "@mui/material";
import IInputProps from "./IInputProps";
import ValidationMessage from "./ValidationMessage";

export default <T,>({ name, label, formik, className }: IInputProps<T, string>) => {
    return (
        <div>
            <label className={className}>
                <Checkbox
                    name={name as string}
                    value={formik.values[name]}
                    checked={formik.values[name] as boolean}
                    onChange={e => formik.setFieldValue(name as string, e.target.checked)}
                    onBlur={formik.handleBlur}
                /> {label}
            </label>
            {formik.touched[name] && formik.errors[name] && <ValidationMessage message={formik.errors[name] as string} />}
        </div>
    );
}